module.exports = __webpack_public_path__ + "img/puzzle.f18fa5e3.svg";